import React from 'react'
import styled from 'styled-components'
import Spliter from '@lib/simba/Spliter'

const Container = styled.div`
    text-transform: uppercase;
    font-size: ${({ theme }) => theme.footer.accroche.fontSize};
`

export default ({ accroche }) => <Container><Spliter s={accroche} /></Container>